import { SET_LAYER_OPACITY, SET_LAYER_VIS } from '../actions/layers';

const defaultLayerVisState = {};
const defaultLayerOpacityState = {};

export const layerVisReducer = (state = defaultLayerVisState, action) => {
  switch (action.type) {
    case SET_LAYER_VIS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export const layerOpacityReducer = (state = defaultLayerOpacityState, action) => {
  switch (action.type) {
    case SET_LAYER_OPACITY:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
